"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurMission() {
  const {
    ref: missionRef,
    isVisible: missionVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.25
  });
  return <section id="our-mission" className="bg-light-background text-foreground-light py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div ref={missionRef} className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {}
          <div className={`space-y-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${missionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-foreground-light">
              Our Mission
            </h2>
            <div className="space-y-4 text-base md:text-lg text-foreground-light/90 leading-relaxed">
              <p>
                The Malta Dental Specialists Association (MDSA) is dedicated to advancing dental excellence across Malta through collaboration, education, and community engagement.
              </p>
              <p>
                We bring together dental specialists from various disciplines to share knowledge, foster professional growth, and elevate the standard of care provided to patients throughout our community.
              </p>
              <p>Our commitment extends beyond individual practice to encompass continuous learning, specialist training, and the promotion of best practices in dental specialization—ensuring that every member has access to the resources and network needed to thrive.</p>
            </div>
          </div>

          {}
          <div className={`flex items-center justify-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${missionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <div className="relative w-full max-w-md lg:max-w-lg overflow-hidden rounded-lg shadow-soft">
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}